function n() {
  return "2.18.1";
}

export { n as getVersion };